import { FormatKind } from '@signalvote/shared';
import { cn } from '@/lib/utils';

interface FormatPickerProps {
  formats: FormatKind[];
  value: FormatKind | null;
  onChange: (next: FormatKind) => void;
  disabled?: boolean;
}

/**
 * FIN-011 — caller decides whether to render this at all by checking
 * `formats.length > 1`. The component itself is unconditional once mounted;
 * keeping the rendering decision at the call site keeps the DOM omitted (not
 * just visually hidden) when only one format is available, per the ticket AC.
 */
export function FormatPicker({ formats, value, onChange, disabled }: FormatPickerProps) {
  return (
    <div>
      <label htmlFor="finance-format-picker" className="text-sm font-medium text-muted-foreground">
        Format
      </label>
      <select
        id="finance-format-picker"
        data-testid="format-picker"
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as FormatKind)}
        className={cn(
          'mt-1 w-full max-w-xs rounded-md border border-input bg-background px-3 py-2 text-sm',
          'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
          disabled && 'opacity-50',
        )}
      >
        {value === null && <option value="">Select a format...</option>}
        {formats.map((f) => (
          <option key={f} value={f}>
            {f}
          </option>
        ))}
      </select>
    </div>
  );
}
